/*
 * @Author: randy
 * @Date: 2020-08-03 14:49:15
 * @LastEditTime: 2020-08-10 13:09:23
 * @Description: 路由
 */
import { generatorDynamicRouter } from "@/utils/generate_routes.js";
import {
  SET_ADD_ROUTES,
  SET_ROUTES,
  SET_DEFAULT_ROUTE_PATH
} from "@/store/types.js";

const permission = {
  state: {
    routes: [],
    addRoutes: [],
    defaultRoutePath: ""
  },
  mutations: {
    [SET_ADD_ROUTES]: (state, payload) => {
      state.addRoutes = payload;
    },
    [SET_ROUTES]: (state, payload) => {
      state.routes = payload;
    },
    [SET_DEFAULT_ROUTE_PATH]: (state, payload) => {
      state.defaultRoutePath = payload;
    }
  },
  actions: {
    GenerateRoutes({ commit }, payload) {
      return new Promise(resolve => {
        generatorDynamicRouter(payload).then(routes => {
          commit(SET_ADD_ROUTES, routes);
          resolve(routes);
        });
      });
    },
    AddCommonRoutes({ commit }, payload) {
      commit(SET_ROUTES, payload);
    },
    setDefaultRoutePath({ commit }, payload) {
      commit(SET_DEFAULT_ROUTE_PATH, payload);
    }
  }
};

export default permission;
